import type { IconProps } from './../../models/icon';

export function PictureIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M15.8398 11.1428C17.4967 11.1428 18.8399 9.79968 18.8399 8.14282C18.8399 6.48597 17.4967 5.14282 15.8398 5.14282C14.183 5.14282 12.8398 6.48597 12.8398 8.14282C12.8398 9.79968 14.183 11.1428 15.8398 11.1428Z"
        />
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M23.1426 2.57146V21.4286L23.1255 16.9886C21.7448 16.5223 20.2971 16.2849 18.8398 16.2857C16.9951 16.2818 15.1691 16.6551 13.4741 17.3829L13.4104 17.4192C12.8835 16.7836 12.2922 16.1973 11.6428 15.6706C9.3192 13.7867 6.40182 12.7895 3.41122 12.8572C2.5542 12.8549 1.69891 12.9341 0.856934 13.0939V2.57146C0.856934 1.62469 1.62445 0.857178 2.57122 0.857178H21.4284C22.3752 0.857178 23.1426 1.62469 23.1426 2.57146ZM15.8398 11.1429C17.4966 11.1429 18.8398 9.79975 18.8398 8.14289C18.8398 6.48603 17.4966 5.14289 15.8398 5.14289C14.1829 5.14289 12.8398 6.48603 12.8398 8.14289C12.8398 9.79975 14.1829 11.1429 15.8398 11.1429Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M21.4284 23.1428H2.57122C1.62445 23.1428 0.856934 22.3754 0.856934 21.4286V13.0939C1.69891 12.9341 2.5542 12.8548 3.41122 12.8571C6.40182 12.7895 9.3192 13.7866 11.6428 15.6706C12.2922 16.1972 12.8835 16.7835 13.4104 17.4192L13.4741 17.3828C15.1691 16.6551 16.9951 16.2817 18.8398 16.2857C20.2971 16.2849 21.7448 16.5223 23.1255 16.9886L23.1426 21.4286C23.1426 22.3754 22.3752 23.1428 21.4284 23.1428Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.57122 23.1429H21.4284C22.3752 23.1429 23.1426 22.3754 23.1426 21.4286V2.57146C23.1426 1.62469 22.3752 0.857178 21.4284 0.857178H2.57122C1.62445 0.857178 0.856934 1.62469 0.856934 2.57146V21.4286C0.856934 22.3754 1.62445 23.1429 2.57122 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M15.8398 11.1428C17.4967 11.1428 18.8399 9.79968 18.8399 8.14282C18.8399 6.48597 17.4967 5.14282 15.8398 5.14282C14.183 5.14282 12.8398 6.48597 12.8398 8.14282C12.8398 9.79968 14.183 11.1428 15.8398 11.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M16.0972 23.1428C15.5452 20.2028 13.9666 17.5546 11.6431 15.6706C9.31948 13.7866 6.40212 12.7895 3.41152 12.8571C2.55571 12.8548 1.70165 12.9339 0.86084 13.0932"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1256 16.9885C21.7449 16.5223 20.2972 16.2849 18.8399 16.2857C16.9952 16.2817 15.1692 16.655 13.4741 17.3828"
        />
      </g>
    </svg>
  );
}
